import type { Directive, DirectiveBinding } from "vue"
import { useAuthStore } from "@/store/authStore"
import type { PermissionRule } from "@/shared/permissions"

type Stash = { placeholder: Comment }
const stashMap = new WeakMap<HTMLElement, Stash>()

function evaluate(binding: DirectiveBinding<PermissionRule>): boolean {
	return useAuthStore().can(binding.value)
}

function hide(el: HTMLElement): void {
	if (stashMap.has(el)) return
	const placeholder = document.createComment("v-can")
	el.parentNode?.replaceChild(placeholder, el)
	stashMap.set(el, { placeholder })
}

function show(el: HTMLElement): void {
	const stash = stashMap.get(el)
	if (!stash) return
	stash.placeholder.parentNode?.replaceChild(el, stash.placeholder)
	stashMap.delete(el)
}

function apply(el: HTMLElement, binding: DirectiveBinding<PermissionRule>): void {
	evaluate(binding) ? show(el) : hide(el)
}

export const vCan: Directive<HTMLElement, PermissionRule> = {
	mounted: apply,
	updated: apply,
	beforeUnmount(el) { stashMap.delete(el) },
}
